<template>
  <div class="shortcut-icon" :class="{ 'shortcut-icon--show': show }">
    <button
      type="button"
      class="shortcut-icon__button"
      @click="toggle"
      :aria-expanded="shortcutOpen"
      :aria-label="label"
      :disabled="!show"
      ref="button"
    >
      <svg
        width="24"
        height="28"
        viewBox="0 0 24 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="shortcut-icon__shape"
        :class="{ 'shortcut-icon__shape--show': !fill }"
        aria-hidden="true"
      >
        <path
          d="M11.3066 0.500823C11.4368 0.507244 11.5629 0.549367 11.6713 0.622671L15.9804 3.52437C16.0788 3.59061 16.1595 3.68036 16.2153 3.78565C16.2711 3.89095 16.3003 4.00852 16.3003 4.12794C16.3003 4.24736 16.2711 4.36494 16.2153 4.47023C16.1595 4.57552 16.0788 4.66527 15.9804 4.73152L11.6713 7.63321C11.5631 7.70601 11.4374 7.7478 11.3076 7.75412C11.1777 7.76044 11.0486 7.73107 10.934 7.66912C10.8194 7.60717 10.7236 7.51497 10.6568 7.40235C10.59 7.28973 10.5547 7.16092 10.5547 7.02964V4.96105C5.64334 5.67204 1.93642 9.91835 1.93642 15.0093C1.93642 20.6268 6.42956 25.1652 11.9911 25.1652C17.5527 25.1652 22.0458 20.6268 22.0458 15.0093C22.0458 14.5561 22.0159 14.1039 21.956 13.6548C21.9434 13.5603 21.9493 13.4641 21.9735 13.3719C21.9977 13.2797 22.0397 13.1932 22.097 13.1174C22.1544 13.0416 22.2259 12.978 22.3076 12.9302C22.3894 12.8823 22.4796 12.8512 22.5732 12.8387C22.7618 12.8137 22.9525 12.8654 23.1034 12.9822C23.2544 13.0991 23.3532 13.2717 23.3784 13.4621C23.4468 13.9754 23.4822 14.4914 23.4822 15.0093C23.4822 21.4109 18.3289 26.6161 11.9911 26.6161C5.65328 26.6161 0.500034 21.4109 0.500034 15.0093C0.500034 9.13494 4.85244 4.21907 10.5547 3.49603V1.22625C10.5545 1.09487 10.5896 0.965899 10.6563 0.853107C10.723 0.740316 10.8188 0.647938 10.9335 0.585834C11.0479 0.523956 11.1769 0.494578 11.3066 0.500823Z"
          fill="white"
          stroke="white"
        />
      </svg>

      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="shortcut-icon__shape shortcut-icon__shape--fill"
        :class="{ 'shortcut-icon__shape--show': fill }"
        aria-hidden="true"
      >
        <path
          d="M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM14.5469 4.50098C14.3664 4.49244 14.1866 4.53293 14.0273 4.61816L13.9131 4.69043C13.8038 4.76966 13.7113 4.87064 13.6416 4.9873C13.5489 5.14263 13.4998 5.32007 13.5 5.50098V6.63574C9.49886 7.35073 6.50012 10.8477 6.5 15C6.5 19.6884 10.3115 23.5 15 23.5C19.6885 23.5 23.5 19.6884 23.5 15C23.5 14.6204 23.4733 14.2429 23.4229 13.8682H23.4238C23.3888 13.6057 23.2502 13.3672 23.04 13.2061C22.83 13.0453 22.565 12.9746 22.3027 13.0088H22.3018C22.1714 13.0261 22.0454 13.0688 21.9316 13.1348C21.818 13.2006 21.7185 13.2882 21.6387 13.3926C21.559 13.4969 21.5005 13.6163 21.4668 13.7432C21.4331 13.8703 21.4248 14.0035 21.4424 14.1338C21.481 14.4209 21.5 14.7101 21.5 15C21.5 18.5956 18.5958 21.5 15 21.5C11.4042 21.5 8.5 18.5956 8.5 15C8.50012 11.9404 10.613 9.35676 13.5 8.67676V9.50098C13.5001 9.68179 13.5496 9.85954 13.6426 10.0146C13.7356 10.1697 13.8689 10.2965 14.0283 10.3818C14.1878 10.4672 14.3672 10.5077 14.5479 10.499C14.7285 10.4903 14.9041 10.4333 15.0547 10.333V10.332L18.0547 8.33301C18.1916 8.24173 18.3042 8.11773 18.3818 7.97266C18.4401 7.86374 18.4771 7.74495 18.4922 7.62305L18.5 7.5C18.4999 7.33554 18.4594 7.17332 18.3818 7.02832C18.3042 6.88325 18.1916 6.75925 18.0547 6.66797L15.0557 4.66992C14.9048 4.56888 14.7282 4.50983 14.5469 4.50098Z"
          fill="url(#paint0_radial_4790_2)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_4790_2"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(15 16) rotate(90) scale(14)"
          >
            <stop stop-color="white" stop-opacity="0.84" />
            <stop offset="1" stop-color="white" />
          </radialGradient>
        </defs>
      </svg>
    </button>
  </div>
</template>

<script>
import SessionData from "@/scripts/sessionData.js";

export default {
  emits: ["toggle"],
  props: {
    shortcutOpen: {
      type: Boolean,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      label: SessionData.lang.Menu.shortcut_button_label || "Shortcut",
    };
  },
  computed: {
    fill() {
      return this.shortcutOpen;
    },
  },
  methods: {
    toggle() {
      this.$emit("toggle");
      this.impulse = 0.25;
      this.baseScale = 0.7;
    },

    animate(t) {
      this.pulseAmount *= 0.9;
      if (this.pulse) {
        this.r += 0.01;
        this.pulseAmount += 0.1;
      } else {
        this.r += 0.001;
      }

      this.baseScale = this.baseScale * 0.95 + 0.05;

      const angle = t * 0.004;
      const renderScale = 0.5 - 0.5 * Math.cos(this.baseScale * Math.PI);
      const extraScale =
        this.pulseAmount * (0.5 + 0.5 * Math.sin(angle)) ** 2.5;

      this.r += this.impulse + 0.01 * extraScale * extraScale * extraScale;
      this.impulse *= 0.96;

      this.$refs.button.style.transform = `rotate(${this.r}rad) scale(${
        renderScale * (1 + 0.15 * extraScale)
      })`;

      this.raf = requestAnimationFrame(this.animate);
    },
  },
  mounted() {
    this.impulse = 0;
    this.pulseAmount = 0;
    this.baseScale = 1;
    this.r = 0;
    this.raf = requestAnimationFrame(this.animate);
  },
  beforeUnmount() {
    cancelAnimationFrame(this.raf);
  },
};
</script>

<style lang="scss">
.shortcut-icon {
  position: fixed;
  bottom: $page-bottom;
  left: calc(var(--container-indent) + 4rem);
  z-index: $z-menu;

  user-select: none;
  pointer-events: none;

  opacity: 0;
  filter: blur(10px);
  transform: scale(0.7);
  transition: opacity 0.5s ease-out, filter 0.5s ease-out,
    transform 0.5s ease-out;

  &--show {
    filter: blur(0px);
    opacity: 1;
    transform: none;
    pointer-events: auto;
  }
}

.shortcut-icon__button {
  @include reset-button;

  will-change: transform;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  animation: shapeRotate 60s linear infinite;
}

.shortcut-icon__shape {
  width: 3rem;
  height: 3rem;
  opacity: 0;

  &--fill {
    position: absolute;
    top: 0;
    left: 0;
  }

  &--show {
    opacity: 1;
  }
}

.shortcut-icon__light {
  will-change: opacity;

  pointer-events: none;
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  width: 16rem;
  height: 16rem;
  margin: -8rem;

  background: radial-gradient(closest-side, #fff, transparent);
}
</style>
